import React, {useEffect, useRef, useState} from "react";
import {IsJsonValid} from "../../utils";
import FormGroup from "../FormGroup";
import geojsonhint from "@mapbox/geojsonhint";

export default function JsonInput({value, onChange, ...props}) {

  const [stringifiedValue, setStringifiedValue] = useState('')
  const inputRef = useRef(null);
  const [cursor, setCursor] = useState(0);
  const addTab = useRef(false);

  useEffect(() => {
    if (typeof (value) === 'object') {
      setStringifiedValue(JSON.stringify(value, null, "\t"))
    }
  }, [value])

  useEffect(() => {
    if (addTab.current) {
      addTab.current = false;
      inputRef.current.selectionStart = cursor;
      inputRef.current.selectionEnd = cursor;
    }
  }, [stringifiedValue])

  const handleTabInsert = (event) => {
    const { selectionStart, selectionEnd } = event.target;
    if (event.keyCode === 9) {
      event.preventDefault();
      const val = stringifiedValue;
      addTab.current = true;
      setStringifiedValue(val.substring(0, selectionStart) + '\t' + val.substring(selectionEnd))
      setCursor( selectionStart + 1);
    }
  }

  const handleChange = (event) => {
    let string = event.target.value;
    setStringifiedValue(string);
  }

  useEffect(() => {
    onChange(stringifiedValue)
  }, [stringifiedValue])

  return (
    <FormGroup
      input="textarea"
      ref={inputRef}
      rows={10}
      onKeyDown={handleTabInsert}
      {...props}
      value={stringifiedValue}
      onChange={handleChange}
    />
  )
}
